<wlm-page-wrapper>
  <ng-container page-top-buttons>
    <div class="buttons-background button-position" *ngIf="dynamicLayoutSettings?.showResetIcon">
      <button
        *ngIf="dynamicLayoutSettings?.showResetIcon"
        mat-icon-button
        [matTooltip]="dynamicLayoutSettings?.labelReset | translate | lowercase"
        color="primary"
        onclick="this.blur()"
        (click)="onResetLayout()"
      >
        <wlm-icon [icon]="'reset-layout'"></wlm-icon>
      </button>
    </div>
  </ng-container>
  <ng-container page-content>
    <wlm-dynamic-layout
      *ngIf="dynamicLayoutSettings"
      [settings]="dynamicLayoutSettings"
    ></wlm-dynamic-layout>
  </ng-container>
</wlm-page-wrapper>
